import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AttributeManagerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  attributeGetList (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/attributeManager/getAttributeList`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attributeSetDefaultValue (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/attributeManager/setDefaultValue`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attributeCreate (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/attributeManager/create`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attributeModify (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/attributeManager/modify`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  attributeDelete (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/attributeManager/delete`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
